import type { TimelineEvent } from './types';
import { EVENT_TYPES } from './types';

export function getBookingTimelineLabel(event: TimelineEvent): string | null {
  if (event.entity_type_name !== 'ahoy_booking') {
    return null;
  }

  const payload = (event.payload ?? {}) as Record<string, unknown>;

  if (event.event_type_name === EVENT_TYPES.PROPERTY_UPDATED) {
    const properties =
      typeof payload.properties === 'object' && payload.properties !== null
        ? (payload.properties as Record<string, unknown>)
        : null;

    if (properties === null) {
      return null;
    }

    if (properties.ahoy_status === 'cancelled') {
      const cancelledBy =
        typeof properties.ahoy_cancelled_by === 'string' &&
        (properties.ahoy_cancelled_by as string).trim()
          ? (properties.ahoy_cancelled_by as string).trim()
          : 'unknown';
      return `Booking cancelled by ${cancelledBy}`;
    }

    if (
      properties.ahoy_start_time !== undefined ||
      properties.ahoy_end_time !== undefined
    ) {
      return 'Booking rescheduled';
    }

    if (
      'ahoy_calendar_event_id' in properties &&
      properties.ahoy_calendar_event_id === null
    ) {
      return 'Calendar event deleted';
    }

    return null;
  }

  if (event.event_type_name === EVENT_TYPES.EMAIL_SENT) {
    const emailType =
      typeof payload.email_type === 'string' && payload.email_type.trim()
        ? payload.email_type.trim()
        : null;
    const recipient =
      typeof payload.recipient_type === 'string' &&
      payload.recipient_type.trim()
        ? payload.recipient_type.trim()
        : null;

    if (emailType !== null && recipient !== null) {
      return `${emailType} email sent to ${recipient}`;
    }

    return null;
  }

  return null;
}
